/**
 * MuiPaper
 *
 * Styles:
 *
 * - [Proto](https://www.figma.com/file/gImnv1p0uOIizS33dnZJa9/Patient-App-2.0?node-id=676%3A37487&mode=dev)
 */
const MuiPaper = {
  styleOverrides: {
    rounded: {
      borderRadius: 16
    }
  }
};
export default MuiPaper;